export default __webpack_public_path__ + "static/media/phone-b.179de122.svg";